import { render, staticRenderFns } from "./ExportCard.vue?vue&type=template&id=1c9a4440"
import script from "./ExportCard.vue?vue&type=script&lang=js"
export * from "./ExportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports